import moment from "moment";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { withStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import Filter from "./components/Filter";
import string from "../../../../utils/string";
import { getColumns } from "./utils/getColumns";
import FilterModal from "./components/FilterModal";
import Table from "../../../../components/Table/Table";
import Scroll from "../../../../components/InfiniteScroll/Scroll";
import {
  findAllOrcamento,
  updateStatusOrcamento,
} from "../../../../services/OrcamentoService";
import ModalOrcamentoOdontologico from "../../../Atendimento/Tabs/Odontograma/Modal/Orcamento/ModalOrcamentoOdontologico";
import SpeedDials from "../../../../components/SpeedDials";
import ModalOrcamentoProcedimento from "./components/Modal/index";
import ModalOrcamentoOrtopedico from "./components/Modal/Ortopedico/index";
import CheckMarkIcon from "../../../../components/Icon/CheckMarkIcon";
import ModalConfirmacao from "../../../../components/Modal/ModalConfirmacao/ModalConfirmacao";
import { orcamentoDefault, statusProcedimentoOptions } from "../../../../stores/Orcamento.store";
import Notification from "../../../../components/Notification";
import { getProfissionalSaudeLogado } from "../../../../services/UsuarioService";
import { checkUserRole } from "../../../../utils/checkUserRole";
import { findAllProcedimentoOdontologicoSemOrcamento } from "../../../../services/OdontogramaService";
import AtendimentoModal from "../../../Atendimento/AtendimentoModal";
import { ReactSelect } from "../../../../components/Select/SelectSearch";
import { TextFieldSearch } from '../../../../components/TextField';
import { findProfissionalSaudeByUnidadeComAgenda } from "../../../../services/ProfissionalSaudeService";
import { findAllSala } from "../../../../services/SalaService";

const primeiroDiaMesAtual = moment()
  .startOf("month")
  .format("YYYY-MM-DD");
const ultimoDiaMesAtual = moment()
  .endOf("month")
  .format("YYYY-MM-DD");

const filtersDefault = {
  profissionalSaude: null,
  procedimento: null,
  dataInicio: primeiroDiaMesAtual,
  dataFim: ultimoDiaMesAtual,
  pageableDTO: {
    pageNumber: 0,
    pageSize: 30,
  },
  status: null,
  tipo: null,
};

const pageableDTODefault = {
  sortDir: "DESC",
  sortField: "dataHoraLancamento",
};

const Orcamentos = observer(
  ({
    classes,
    odontogramaStore,
    extratoStore,
    sujeitoAtencaoStore,
    history,
    orcamentoStore,
    unidadeStore,
    atendimentoStore,
  }) => {
    const { dadosModalConfirmacao } = odontogramaStore;
    const { notification, closeAlertMessage } = orcamentoStore;

    const [filters, setFilters] = useState({ ...filtersDefault, search: "" });
    const [openfilterModal, setOpenFilterModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [orcamentos, setOrcamentos] = useState([]);
    const [last, setLast] = useState(false);
    const [openModalOrcamento, setOpenModalOrcamento] = useState(false);
    const [ordenarTabela, setOrdenarTabela] = useState(pageableDTODefault);
    const [orcamentoSelectedId, setOrcamentoSelectedId] = useState(null);
    const [typeOfOrcamento, setTypeOfOrcamento] = useState("");
    const [orcamentoComparar,setOrcamentoComparar]=useState(null)
    const [isGerenciador,setIsGerenciador]=useState(false)
    const [linkedAgendamento, setLinkedAgendamento] = useState(false)
    const [openProfissionalModal, setOpenProfissionalModal] = useState(false)
    const [selectedOrcamento, setSelectedOrcamento] = useState(null)
    const [profissionaisSaude, setProfissionaisSaude] = useState([])
    const [selectedProfissional, setSelectedProfissional] = useState(null)
    const [openSalaModal, setOpenSalaModal] = useState(false)
    const [selectedSala, setSelectedSala] = useState(null)

    const {
      profissionalSaude,
      search,
      procedimento,
      pageableDTO,
      status,
      tipo,
    } = filters;

    const { objView } = sujeitoAtencaoStore;
    const whitelabel = JSON.parse(
      localStorage["_immortal|unidadeLogada"] || null
    )?.rede?.whitelabel;
    const is3dpe = whitelabel?.nome === "_3DPE";

    const actions = [
      ...(is3dpe ?
        [
          {
            name: "Palmilhas 3DPÉ",
            buttonClasses: classes.buttonAddOrtopedico,
            tipo: "ORTOPEDICO",
          },
        ]
        : [
          {
            name: "Procedimento",
            buttonClasses: classes.buttonAddConsulta,
            tipo: "PROCEDIMENTO",
          },
          {
            name: "Odontológico",
            buttonClasses: classes.buttonAddProcedimento,
            tipo: "ODONTOLOGICO",
          },
        ])

    ];

    const popperRef = useRef(null);

    useEffect(() => {
      loadOrcamentos(true);
    }, [ordenarTabela]);

    useEffect(() => {
      const dados = history.location.state
      if (dados?.agendamentoId && dados?.orcamentoId && dados.isModalSelectOrcamento) {
        getOrcamentosByAgendamento(dados.orcamentoId, dados.tipoOrcamento)
      }
      if (dados?.agendamentoId && dados?.tipoOrcamento && !dados.orcamentoId) {
        setLinkedAgendamento(true)
        getOrcamentoDados(dados)
      }
    }, []);

    useEffect(() => {
      const stateData = history.location.state;
      if (stateData?.orcamento) {
        handleOpenOrcamentoModal(stateData.orcamento);
      }
    }, []);

    useEffect(() => {
      checkRoles()
    }, [ordenarTabela]);

    const checkRoles = async() =>{
      const isGerenciador = await checkUserRole("ROLE_GERENCIADOR_ORCAMENTO_UPDATE")
      setIsGerenciador(isGerenciador)
    }

    const handleOpenOrcamentoModal = async (data) => {
      if(data.tipo === "ORTOPEDICO"){
        await orcamentoStore.getDadosOrcamentoOrtopedico(data.id)
      }else{
        const orcamento = await orcamentoStore.getDadosOrcamentoOdontologico(data.id);
        setOrcamentoComparar(orcamento)
      }
      setOrcamentoSelectedId(data.id);
      setTypeOfOrcamento(data.tipo);
      setOpenModalOrcamento(true);
    };


    const handleClickFilterButton = () => {
      setOpenFilterModal(true);
    };

    const handleFilterChange = (value, field) => {
      setFilters({
        ...filters,
        [field]: value,
      });
    };

    const getOrcamentoDados = async (dados) => {
      setTypeOfOrcamento(dados?.tipoOrcamento)
      await getDadosOrcamento({ agendamento: dados?.dadosAgendamento, tipo: dados?.tipoOrcamento })
      setOpenModalOrcamento(true)
    }

    const getDadosOrcamento = async ({ agendamento, tipo }) => {
      const { convenio, sujeitoAtencao, procedimentos } = agendamento
      const { convenioAgendamentoTipo, convenioProcedimentos, ...rest } = convenio || {}

      let procedimentosOdontologicoOrcamento;
      let procedimentoFormated = procedimentos

      if (tipo === 'ODONTOLOGICO') {

        const orcamentoProcedimentos = procedimentos.map(item => {
          const { procedimentoOdontologico } = item;
          return {
            ...item,
            ...procedimentoOdontologico,
            status: statusProcedimentoOptions.find(element => element.value === item.procedimentoOdontologico.status),
            checked: true,
          }
        })

        const procedimentosResponse = await findAllProcedimentoOdontologicoSemOrcamento({
          sujeitoAtencaoId: sujeitoAtencao.id,
          orcado: false,
          procedimentoRealizado: false,
          pageableDTO: { sortDir: "DESC", sortField: "dataHoraLancamento" }
        });

        procedimentosOdontologicoOrcamento = procedimentosResponse.map(item => {
          return {
            ...item,
            checked: false,
            status: statusProcedimentoOptions.find(element => element.value === item.status),
            valorUnitario: "",
          }
        });

        procedimentoFormated = [...orcamentoProcedimentos, ...procedimentosOdontologicoOrcamento]
      }

      const orcamentoComDadosAgendamento = {
        ...orcamentoDefault,
        convenio: {
          ...rest
        },
        ...(agendamento.procedimentos && {
          orcamentoProcedimentos: procedimentoFormated
        }
        ),
        ...(sujeitoAtencao && { sujeitoAtencao: { ...sujeitoAtencao } }),
        profissionalSaude: agendamento?.profissionalSaude,
        tipo,
        agendamento: {
          id: agendamento?.id
        }
      }

      orcamentoStore.orcamento = { ...orcamentoComDadosAgendamento }
      orcamentoComDadosAgendamento.tipo === 'ODONTOLOGIOCO' && orcamentoStore.getDadosOrcamentoOdontologico(null, sujeitoAtencao, orcamentoStore.orcamento)
    }

    const getOrcamentosByAgendamento = async (orcamentoId, tipo) => {
      try {
        let orcamento;
        if (tipo === 'ODONTOLOGICO') {
          orcamento = await orcamentoStore.getDadosOrcamentoOdontologico(orcamentoId, sujeitoAtencaoStore.idOpened);
        } else {
          orcamento = await orcamentoStore.findOrcamentoById(orcamentoId)
        }
        setOrcamentoComparar(orcamento)
        setOrcamentoSelectedId(orcamento.id);
        setTypeOfOrcamento(orcamento.tipo);
        setOpenModalOrcamento(true)
      } catch (error) {
        console.error(error);
      }
    };

    const loadOrcamentos = async (clear = false) => {
      try {
        if(isLoading) return;

        setIsLoading(true);

        let orcamentoList = orcamentos;
        let page = pageableDTO.pageNumber;

        if (clear) {
          orcamentoList = [];
          page = 0;
        }

        const response = await findAllOrcamento({
          profissionalSaudeId: profissionalSaude?.value,
          sujeitoAtencaoId: sujeitoAtencaoStore.idOpened,
          search,
          procedimentoId: procedimento?.id,
          pageableDTO: {
            ...pageableDTO,
            ...ordenarTabela,
            pageNumber: page,
          },
          status: status?.value,
          ...(tipo?.value && {
            tipo: tipo?.value
          })
        });

        setOrcamentos([...orcamentoList, ...response.content]);
        setFilters({
          ...filters,
          pageableDTO: {
            ...pageableDTO,
            pageNumber: page + 1,
          },
        });
        setLast(response.last);
      } catch {
        odontogramaStore.openNotification(
          "Erro ao carregar os orcamentos",
          "error"
        );
      } finally {
        setIsLoading(false);
      }
    };

    const handleClickVisualizar = async (closePopper, data) => {
      if(data.tipo === "ORTOPEDICO"){
        await orcamentoStore.getDadosOrcamentoOrtopedico(data.id)
      }else{
        const orcamento = await orcamentoStore.getDadosOrcamentoOdontologico(data.id);
        setOrcamentoComparar(orcamento)
      }
      setOrcamentoSelectedId(data.id);
      setTypeOfOrcamento(data.tipo);
      setOpenModalOrcamento(true);
      return closePopper;
    };

    const handleClickFaturar = async (closePopper,orcamentoId) => {
      try {
        if(is3dpe) {
          // const link3dpe = await urlPainel3dpe();
          const link3dpe = "https://interno.3dpedoctors.com.br/compra-palmilha";

          window.open(link3dpe, "_blank");

          return closePopper;
        };

        await unidadeStore.inicializaConfiguracaoUnidade();
        
        const { configuracaoUnidade } = unidadeStore;
        const { azulControleAtivado, utilizaFinanceiroAppHealth } =
          configuracaoUnidade || {};

        const showFinanceiroAzulControle =
          azulControleAtivado && !utilizaFinanceiroAppHealth;

        showFinanceiroAzulControle
          ? await orcamentoStore.handleFaturarFinanceiroCompleto(orcamentoId)
          : await handleFaturarFinanceiroSimples(orcamentoId);

        dadosModalConfirmacao.open = false;

        return closePopper;
      } catch (e) {
        console.error(e);
      }
    };

    const handleInativar = async (closePopper, data) => {
      try {
        await updateStatusOrcamento({orcamentoId: data.id, status: "INATIVO"});
        await loadOrcamentos(true);
        return closePopper;
      } catch (e) {
        orcamentoStore.openNotification(
          "Erro ao inativar o orcamento",
          "error"
        );
      }
    };

    const handleAtivar = async (closePopper, data) => {
      try {
        await updateStatusOrcamento({
          orcamentoId: data.id,
          status: "PENDENTE",
        });
        await loadOrcamentos(true);
        return closePopper;
      } catch (e) {
        orcamentoStore.openNotification(
          "Erro ao inativar o orcamento",
          "error"
        );
      }
    };

    const handleFaturarFinanceiroSimples = async (orcamentoId) => {
      try {
        await orcamentoStore.getDadosOrcamentoOdontologico(
          orcamentoId
        );
        const {
          profissionalSaude,
          valor,
          desconto,
          tipoDesconto,
          orcamentoProcedimentos,
        } = orcamentoStore.orcamento || {};

        const orcamento = {
          ...orcamentoStore.orcamento,
          subtotal: string.calculaDesconto(valor, desconto, tipoDesconto),
        };

        const procedimentos = orcamentoProcedimentos.filter(item => item.checked).map(item => {
          const procedimento = item.procedimento?.id? item.procedimento : item.procedimentoOdontologico?.procedimento;

          return procedimento;
        })

        extratoStore.preencherDadosOrcamentoOdontologico({
          tipo: "RECEITA",
          sujeitoAtencao: objView,
          ...(profissionalSaude?.id && {
            profissionalSaude: {
              ...profissionalSaude,
              label: profissionalSaude.nome,
              value: profissionalSaude.id,
            },
          }),
          procedimentos,
          orcamento: orcamento,
        });
        history.push("/financeiro");
        dadosModalConfirmacao.open = false;
      } catch (error) {
        console.log(error);
      }
    };

    const handleExcluir = async (closePopper, data) => {
      await updateStatusOrcamento({
        orcamentoId: data.id,
        status: "CANCELADO",
      });

      loadOrcamentos(true);
      return closePopper;
    };

    const handleOpenAgendamento = async (closePopper, data, isSala) => {
      setSelectedOrcamento(data);
      
      if (isSala) {
        setSelectedSala(null);
        setOpenSalaModal(true);
      } else {
        await loadProfissionaisSaude();
        setSelectedProfissional(data.profissionalSaude || null);
        setOpenProfissionalModal(true);
      }
      
      return closePopper;
    };

    const loadProfissionaisSaude = async () => {
      try {
        const unidadeLogada = JSON.parse(localStorage['_immortal|unidadeLogada']);
        const response = await findProfissionalSaudeByUnidadeComAgenda({ unidadeId: unidadeLogada?.id });
        setProfissionaisSaude(response?.data?.data?.findProfissionalSaudeByUnidadeComAgenda || []);
      } catch (error) {
        console.error('Erro ao carregar profissionais:', error);
      }
    };

    const loadSalas = async (search, loadedOptions, { page }) => {
      return handleLoadMoreSalas({
        search,
        data: { page }
      })
    }

    const handleLoadMoreSalas = async ({ search, data }) => {
      let pageableDTO = {
        sortDir: 'ASC',
        sortField: 'nome',
        pageNumber: data.page,
        pageSize: 20,
      };

      const response = await findAllSala({
        search,
        ativo: true,
        pageableDTO
      });

      const { content, last } = response?.data?.data?.findAllSala;

      if (content) {
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: data.page + 1
          },
        };
      }
    };

    const handleConfirmProfissional = async () => {
      setOpenProfissionalModal(false);
      
      await atendimentoStore.changeOpenFromOrcamento(selectedOrcamento, selectedProfissional);
      atendimentoStore.open = true;

    };

    const handleConfirmSala = async () => {
      setOpenSalaModal(false);
      
      await atendimentoStore.changeOpenFromOrcamento(selectedOrcamento, null, selectedSala);
      atendimentoStore.open = true;
    };

    const handleCloseAtendimentoModal = () => {
      atendimentoStore.open = false;
      setSelectedOrcamento(null);
      setSelectedProfissional(null);
      setSelectedSala(null);
    };

    const handleCloseProfissionalModal = () => {
      setOpenProfissionalModal(false);
      setSelectedOrcamento(null);
      setSelectedProfissional(null);
    };

    const handleCloseSalaModal = () => {
      setOpenSalaModal(false);
      setSelectedOrcamento(null);
      setSelectedSala(null);
    };

    const handleClickOrdenar = (value) => {
      const sortDir =
        ordenarTabela.sortField !== value
          ? "ASC"
          : ordenarTabela.sortDir === "ASC"
          ? "DESC"
          : "ASC";
      setOrdenarTabela({
        sortDir: sortDir,
        sortField: value,
      });
    };

    const handleClickAction = async(action) => {
      const { dadosConvenio } = objView || {};
      const { convenio } = dadosConvenio || {};

      const profissionalLogado = await getProfissionalSaudeLogado();

      orcamentoStore.orcamento = {
        ...orcamentoDefault,
        tipo: action.tipo,
        ...( convenio?.id && {
          convenio: {
            ...convenio,
            label: convenio?.descricao,
            value: convenio?.id,
          }
        }),
        profissionalSaude: profissionalLogado,
      };
      setTypeOfOrcamento(action.tipo);
      setOpenModalOrcamento(true);
    };

    const handleCloseModalConfirmacao = () => {
      setOpenModalOrcamento(false);
      orcamentoStore.orcamento = orcamentoDefault;
      dadosModalConfirmacao.open = false;
    };

    return (
      <div className={classes.content}>
        <Filter
          id="pac-orc-flt"
          onClickFilterButton={handleClickFilterButton}
          onChange={handleFilterChange}
          filter={filters}
          handleApplyFilter={() => loadOrcamentos(true)}
          isLoading={isLoading}
        />
        <div className={classes.contentTable}>
          <Scroll
            loadMore={() => loadOrcamentos()}
            hasMore={!last}
            pageStart={0}
            initialLoad={false}
            className={classes.scrollContainer}
          >
            <Table
              dados={orcamentos}
              columns={getColumns({
                handleClickVisualizar,
                whitelabel,
                popperRef,
                isGerenciador,
                functionsPopper: {
                  handlePrint: () => {},
                  handleExcluir,
                  handleDownload: () => {},
                  handleFaturar: handleClickFaturar,
                  handleInativar,
                  handleAtivar,
                  handleOpenAgendamento,
                },
              })}
              emptyMessage={
                <div className={classes.emptyMessage}>
                  <span>Nenhum registro encontrado</span>
                </div>
              }
              isLoading={isLoading}
              comOrdenacao
              ordenarTabela={ordenarTabela}
              handleClickOrdenar={handleClickOrdenar}
              clickable
              handleClick={(id, row) => handleClickVisualizar(null, row)}
            />
          </Scroll>
        </div>

        {openfilterModal && (
          <FilterModal
            open={openfilterModal}
            handleClose={() => setOpenFilterModal(false)}
            isLoading={isLoading}
            handleApplyFilter={() => loadOrcamentos(true)}
            filters={filters}
            resetFilter={() => setFilters({ ...filtersDefault })}
            handleFilterChange={handleFilterChange}
          />
        )}
        {openModalOrcamento && typeOfOrcamento === "ODONTOLOGICO" && (
          <ModalOrcamentoOdontologico
            openModalOrcamento={openModalOrcamento}
            sujeitoAtencaoSelected={objView}
            setOpenModalOrcamento={setOpenModalOrcamento}
            loadList={() => loadOrcamentos(true)}
            orcamentoComparar={{...orcamentoComparar}}
            linkedAgendamento={linkedAgendamento}
          />
        )}
        {openModalOrcamento && typeOfOrcamento === "PROCEDIMENTO" && (
          <ModalOrcamentoProcedimento
            openModalOrcamento={openModalOrcamento}
            sujeitoAtencaoSelected={objView}
            setOpenModalOrcamento={setOpenModalOrcamento}
            loadList={() => loadOrcamentos(true)}
            orcamentoComparar={{...orcamentoComparar}}
            linkedAgendamento={linkedAgendamento}
          />
        )}
        {openModalOrcamento && typeOfOrcamento === "ORTOPEDICO" && (
          <ModalOrcamentoOrtopedico
            openModalOrcamento={openModalOrcamento}
            sujeitoAtencaoSelected={objView}
            setOpenModalOrcamento={setOpenModalOrcamento}
            loadList={() => loadOrcamentos(true)}
          />
        )}
        {dadosModalConfirmacao.open && (
          <ModalConfirmacao
            id="pac-orc-mdl-apr"
            open={dadosModalConfirmacao.open}
            icon={<CheckMarkIcon />}
            onClose={() => (dadosModalConfirmacao.open = false)}
            color={"green"}
            title={"Orçamento aprovado! Deseja faturar?"}
            buttons={{
              labelPrimaryButton: "Fatura depois",
              labelSecondButton: "Faturar agora",
              colorCustomPrimaryButton: "transparency",
              colorCustomSecondButton: "green",
              handlePrimaryButton: () => handleCloseModalConfirmacao(),
              handleSecondButton: () => handleClickFaturar(null, orcamentoSelectedId),
              idPrimaryButton: "pac-orc-btn-fdp",
              idSecondButton: "pac-orc-btn-fag",
            }}
          ></ModalConfirmacao>
        )}
        <Notification
          close={closeAlertMessage}
          reset={closeAlertMessage}
          isOpen={notification.isOpen}
          variant={notification.variant}
          message={notification.message}
        />
        {atendimentoStore.open && (
          <AtendimentoModal
            open={atendimentoStore.open}
            onClose={handleCloseAtendimentoModal}
          />
        )}
        {openProfissionalModal && (
          <ModalConfirmacao
            id="pac-orc-mdl-pro"
            open={openProfissionalModal}
            onClose={handleCloseProfissionalModal}
            title="Profissional saúde"
            buttons={{
              labelPrimaryButton: "Cancelar",
              labelSecondButton: "Confirmar",
              colorCustomPrimaryButton: "transparency",
              colorCustomSecondButton: "green",
              handlePrimaryButton: handleCloseProfissionalModal,
              handleSecondButton: handleConfirmProfissional,
              disabledSecondButton: !selectedProfissional,
              idPrimaryButton: "pac-orc-btn-cnc-pro",
              idSecondButton: "pac-orc-btn-cnf-pro",
            }}
          >
            <div className={classes.professionalSelectContainer}>
              <div className={classes.selectLabel}>
                Selecione o profissional para realizar o agendamento:
              </div>
              <ReactSelect
                id="pac-orc-sel-pro"
                value={selectedProfissional}
                onChange={setSelectedProfissional}
                options={profissionaisSaude}
                getOptionLabel={(option) => option.nome}
                getOptionValue={(option) => option.id}
                placeholder="Selecione um profissional"
                className={classes.reactSelect}
              />
            </div>
          </ModalConfirmacao>
        )}
        {openSalaModal && (
          <ModalConfirmacao
            id="pac-orc-mdl-sal"
            open={openSalaModal}
            onClose={handleCloseSalaModal}
            title="Sala"
            buttons={{
              labelPrimaryButton: "Cancelar",
              labelSecondButton: "Confirmar",
              colorCustomPrimaryButton: "transparency",
              colorCustomSecondButton: "green",
              handlePrimaryButton: handleCloseSalaModal,
              handleSecondButton: handleConfirmSala,
              disabledSecondButton: !selectedSala,
              idPrimaryButton: "pac-orc-btn-cnc-sal",
              idSecondButton: "pac-orc-btn-cnf-sal",
            }}
          >
            <div className={classes.professionalSelectContainer}>
              <div className={classes.selectLabel}>
                Selecione a sala para realizar o agendamento:
              </div>
              <TextFieldSearch
                id="pac-orc-txt-sal"
                placeholder="Selecione uma sala"
                loadOptions={loadSalas}
                withPaginate
                value={selectedSala}
                getOptionLabel={(option) => option?.nome}
                getOptionValue={(option) => option?.id}
                onChange={setSelectedSala}
                debounceTimeout={300}
                additional={{
                  page: 0,
                }}
                className={classes.reactSelect}
              />
            </div>
          </ModalConfirmacao>
        )}
        <div className={classes.floatButtonsContainer}>
          <SpeedDials
            id="pac-orc-btn-add"
            actions={actions}
            onClickAction={handleClickAction}
            withTooltip={false}
          />
        </div>
      </div>
    );
  }
);

const style = {
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "16px 16px 0 16px",
    gap: "16px",
  },
  contentTable: {
    display: "flex",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
    height: "calc(100vh - 255px)",
  },
  emptyMessage: {
    display: "flex",
    justifyContent: "center",
    marginTop: "8px",
  },
  scrollContainer: {
    height: "100%",
  },
  floatButtonsContainer: {
    position: "absolute",
    bottom: 24,
    right: 37,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "end",
    columnGap: "8px",
    "& > div": {
      alignItems: "flex-end",
    },
  },
  buttonAddProcedimento: {
    backgroundColor: "#707C97 !important",
    width: "fit-content",
    borderRadius: "100px",
    border: "2px solid rgba(220, 220, 220, 0.2)",
    padding: "8px 16px",
    color: "#fff",
    whiteSpace: "nowrap",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "bold",
    display: "flex",
  },
  buttonAddConsulta: {
    backgroundColor: "#26ACA9 !important",
    width: "fit-content",
    borderRadius: "100px",
    border: "2px solid rgba(220, 220, 220, 0.2)",
    padding: "8px 16px",
    color: "#fff",
    whiteSpace: "nowrap",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "bold",
  },
  buttonAddOrtopedico: {
    backgroundColor: "#1C5F8C !important",
    width: "fit-content",
    borderRadius: "100px",
    border: "2px solid rgba(220, 220, 220, 0.2)",
    padding: "8px 16px",
    color: "#fff",
    whiteSpace: "nowrap",
    textTransform: "none",
    fontSize: "12px",
    fontWeight: "bold",
  },
  professionalSelectContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    padding: "16px 0",
  },
  selectLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
    marginBottom: "8px",
  },
  reactSelect: {
    width: "100%",
  },
};

const OrcamentosWithStyles = withStyles(style)(Orcamentos);
export default inject(
  "odontogramaStore",
  "extratoStore",
  "sujeitoAtencaoStore",
  "orcamentoStore",
  "unidadeStore",
  "atendimentoStore"
)(OrcamentosWithStyles);
